<template>
  <div>
      <iframe :src="`/api/static/html/${page}`" frameborder="0" class="ifram"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
        page: null
    };
  },
  created () {
      this.page = this.$route.params.page
  },
  mounted(){
      document.getElementsByClassName("head-div")[0].style.display="none";
      document.getElementsByClassName("footer")[0].style.display="none";
  }, 
};
</script>
<style scoped>
.ifram {
    width: 100%;
    min-height: 100vh;
}
</style>